import { PointWithMetadata } from "@/tools/create/lss-from-map/types";
import { Alert, Button, Col, Row } from "antd";
interface PointsStageSidebarProps {
  arePointsValid: boolean;
  onContinue: () => void;
  onGoBack: () => void;
  points: PointWithMetadata[];
}
export const PointsStageSidebar = ({
  arePointsValid,
  onGoBack,
  onContinue
}: PointsStageSidebarProps) => {
  return <Row gutter={[16, 16]} data-sentry-element="Row" data-sentry-component="PointsStageSidebar" data-sentry-source-file="PointsStageSidebar.tsx">
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PointsStageSidebar.tsx">Click and drag grid points within your polygon.</Col>
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PointsStageSidebar.tsx">
        <Alert type="warning" message="Tip: The presence of water will skew results for your Large Site. Remove all grid markers that appear within
          bodies of water." data-sentry-element="Alert" data-sentry-source-file="PointsStageSidebar.tsx" />
      </Col>
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PointsStageSidebar.tsx">
        <Button block onClick={onGoBack} data-sentry-element="Button" data-sentry-source-file="PointsStageSidebar.tsx">
          Go Back
        </Button>
      </Col>
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PointsStageSidebar.tsx">
        {/* Disable if points invalid. */}
        <Button block disabled={!arePointsValid} type="primary" onClick={onContinue} data-sentry-element="Button" data-sentry-source-file="PointsStageSidebar.tsx">
          Confirm Asset Settings
        </Button>
      </Col>
    </Row>;
};